import { useMemo } from 'react';

import { UseTimeSpanShorteningReasonForChildren } from '@dreryk/egabinet-ezwm-frontend-api';

import { BindingCreator } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import { MedicalDeviceOrderAdditionalIndicationsFormBeanPart } from '../medicalDeviceOrder.types';

type ShorteningDeviceUseTimeSpanReasonProps = {
   readonly register: BindingCreator<MedicalDeviceOrderAdditionalIndicationsFormBeanPart>;
};

export const ShorteningDeviceUseTimeSpanReason = (props: ShorteningDeviceUseTimeSpanReasonProps): JSX.Element => {
   const items: RadioGroupItem<UseTimeSpanShorteningReasonForChildren>[] = useMemo(
      () => [
         {
            id: 'SURGERY',
            label: medicalDevicesTranslationKeys.fields.shorteningDeviceUseTimeSpanReason.SURGERY,
         },
         {
            id: 'DISEASE',
            label: medicalDevicesTranslationKeys.fields.shorteningDeviceUseTimeSpanReason.DISEASE,
         },
         {
            id: 'REHABILITATION',
            label: medicalDevicesTranslationKeys.fields.shorteningDeviceUseTimeSpanReason.REHABILITATION,
         },
         {
            id: 'PHYSICAL_DEVELOPMENT',
            label: medicalDevicesTranslationKeys.fields.shorteningDeviceUseTimeSpanReason.PHYSICAL_DEVELOPMENT,
         },
      ],
      []
   );

   return (
      <RadioGroup
         testId={'shorteningDeviceUseTimeSpanReason'}
         items={items}
         controller={props.register('shorteningDeviceUseTimeSpanReason', {
            required: true,
         })}
         label={medicalDevicesTranslationKeys.fields.shorteningDeviceUseTimeSpanReason.label}
      />
   );
};
